import { Notify } from "@/components/ui/notify";
import type { ValidationResult } from "../canvas-validator";
import { describeError, describeWarning } from "./helpers";

export interface ValidationBannersProps {
  errors: ValidationResult["errors"];
  warnings: ValidationResult["warnings"];
}

export function ValidationBanners({ errors, warnings }: ValidationBannersProps) {
  return (
    <>
      {errors.length > 0 ? (
        <Notify.Banner variant="danger" title="Bloqueando salvar:">
          <ul className="ml-4 list-disc">
            {errors.map((e, i) => (
              <li key={i}>{describeError(e)}</li>
            ))}
          </ul>
        </Notify.Banner>
      ) : null}

      {warnings.length > 0 ? (
        <Notify.Banner variant="warning" title="Atenção:">
          <ul className="ml-4 list-disc">
            {warnings.map((w, i) => (
              <li key={i}>{describeWarning(w)}</li>
            ))}
          </ul>
        </Notify.Banner>
      ) : null}
    </>
  );
}
